// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { connect, useDispatch, useStore, useSelector } from '/Users/linqin/Documents/project/luosen_base/luosen_back/node_modules/@umijs/plugins/libs/dva.tsx';
export { getDvaApp } from './dva';
